<template>
    <div>
        <Head title="Girls"/>
        <h1 class="mb-8 text-3xl font-bold">Girls</h1>
        <div class="flex items-center justify-between mb-6">
<!--            <search-input v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">-->
<!--            </search-input>-->
            <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
                <label class="block mt-4 text-gray-700">Is moderated:</label>
                <select v-model="form.moderated" class="form-select mt-1 w-full">
                    <option :value="null">All</option>
                    <option :value="true">Only moderated</option>
                    <option :value="'false'">Only not moderated</option>
                </select>
            </search-filter>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <div class="mb-5 mt-5 ml-5">
                <ul>
                    <li v-for="item in stat">
                        {{item.label}} - {{item.count}}
                    </li>
                </ul>
            </div>
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">ID</th>
                    <th class="pb-4 pt-6 px-6">Nickname</th>
                    <th class="pb-4 pt-6 px-6">Name</th>
                    <th class="pb-4 pt-6 px-6">Moderated</th>
                    <th class="pb-4 pt-6 px-6" colspan="2">CreatedAt</th>
                </tr>
                <tr v-for="girl in girls" :key="girl.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                              :href="`/girls/${girl.id}`">
                            {{ girl.id }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" :href="`/girls/${girl.id}`" tabindex="-1">
                            {{ girl.nickname }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" :href="`/girls/${girl.id}`" tabindex="-1">
                            {{ girl.firstname }} {{ girl.lastname }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" :href="`/girls/${girl.id}`" tabindex="-1">
                            {{ girl.is_moderated ? '✅' : '⛔️' }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" :href="`/girls/${girl.id}`" tabindex="-1">
                            {{ girl.created_at }}
                        </Link>
                    </td>
                    <td class="w-px border-t">
                        <Link class="flex items-center px-4" :href="`/girls/${girl.id}`" tabindex="-1">
                            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400"/>
                        </Link>
                    </td>
                </tr>
                <tr v-if="girls.length === 0">
                    <td class="px-6 py-4 border-t" colspan="4">No girls found.</td>
                </tr>
            </table>
            <div class="bg-white p-4 flex items-center flex-wrap">
                <nav aria-label="Page navigation">
                    <ul class="inline-flex">
                        <li v-for="link in paginator.links">
                            <Link :class="[link.active ? 'bg-indigo-600 text-white' : 'text-indigo-600 bg-white']" class="px-4 py-2 transition-colors duration-150 border border-indigo-600 focus:shadow-outline" :href="`${link.url}`" v-if="link.url">
                                {{link.label}}
                            </Link>
                            <Link class="px-4 py-2 transition-colors duration-150 border border-indigo-600 focus:shadow-outline" :href="`#`" v-else>
                                {{link.label}}
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import SearchInput from "@/Shared/SearchInput";

export default {
    components: {
        SearchInput,
        Head,
        Icon,
        Link,
        SearchFilter,
    },
    layout: Layout,
    props: {
        filters: Object,
        girls: Array,
        paginator: Object,
        stat: Array,
    },
    data() {
        return {
            form: {
                search: this.filters.search,
                moderated: this.filters.moderated
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/girls', pickBy(this.form), {preserveState: true})
            }, 150),
        },
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
